import CrudTableContainer from "../../containers/CrudTableContainer";

const CrudTablePage = () => {
  return <CrudTableContainer />;
};

export default CrudTablePage;
